import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import {
	sortUsers,
	filterNonGuestUsers,
	getSavedTableSettings,
	getTableStyleProps,
	encodeUser,
} from 'utils/users';
import { writeUserSettings } from 'redux/modules/session';
import { Select } from '../../components/Features/components';
import SelectArrow from '@material-ui/icons/KeyboardArrowDown';
import { Scrollbars } from 'react-custom-scrollbars';
import classNames from 'classnames';
import { hideModal, resetModal } from 'redux/modules/modal';
import { updatePendingReduceUser, batchReduceUsers } from 'redux/modules/companies';
import PropTypes from 'prop-types';
import _ from 'lodash';
import ERRORS from '../../errors/errorids';
import RolesTooltip from '../../components/RolesTooltip';

import {
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	Tooltip,
	Grid,
	Dialog,
	DialogTitle,
	DialogContent,
	Button,
	Typography,
	IconButton,
	List,
	ListItem
} from '@material-ui/core';

import { SortArrow, Info, XIcon, SpinnerIcon } from '../../theme/icons';

import {
	QUANTITY_TYPE,
	USER_TABLE_REDUCE_USERS,
	USER_ROLE_ADMIN,
	USER_ROLE_BASIC,
	TABLE_COLUMNS,
	SORT_ORDER,
	USER_TABLE_ADMINS_AND_MEMBERS,
	CAP_KEY,
	USER_PAGE_SETTINGS_KEY,
	REDUCE_ACTION,
	USER_ROLE_GUEST
} from '../../config';

import { trackReduceUsersModal, trackReducedUsers } from 'lib/Segment/customTrackers';
import { getTrackingOptions } from 'lib/Segment/helpers';

import i18n from 'i18n/i18n';
const localize = i18n.loc.localize;

const REDUCE_ACTIONS = [
	{ key: REDUCE_ACTION.KEEP_ROLE, value: localize('subscription-reduce-action-keep-role') },
	{ key: REDUCE_ACTION.CHANGE_TO_GUEST, value: localize('subscription-reduce-action-change-to-guest') },
	{ key: REDUCE_ACTION.REMOVE, value: localize('subscription-reduce-action-remove') },
];

const styles = theme => {
	return {
		/* Dialog */
		dialogPaper: {
			minWidth: 960,
			[theme.breakpoints.down('sm')]: {
				minWidth: '90%'
			}
		},
		dialogWrapper: {
			position: 'relative',
			padding: '15px 10px',
			minHeight: 576
		},
		dialogTitle: {
			'& h6': {
				fontWeight: 600,
				fontSize: '28px',
				lineHeight: 1.4,
				marginBottom: 5,
				textAlign: 'left'
			}
		},
		/* close button */
		closeDialog: {
			position: 'absolute',
			top: 10,
			right: 10
		},
		closeDialogIcon: {
			color: '#6F99BD',
			width: '20px',
			height: '20px'
		},

		text: {
			textAlign: 'left',
			color: '#000',
			opacity: 1
		},

		/* intro description */
		description: {
			marginBottom: 20
		},

		remaining: {
			marginBottom: 20,
			'& span': {
				fontWeight: 600,
				color: theme.palette.colors.alpha
			}
		},

		introText: {
			color: '#000',
			textAlign: 'left',
			opacity: 1
		},
		
		/* buttons */
		buttonsContainer: {
			paddingTop: 40
		},
		aboutRolesGridElement: {
			paddingTop: 8
		},
		aboutRoles: {
			display: 'inline-block',
			marginRight: 5,
			fontFamily: '"Open Sans Xara", Arial, Helvetica, sans-serif',
			fontWeight: 'normal',
			fontSize: 14,
			lineHeight: 1.5,
			opacity: 1
		},
		cancelButtonGridElement: {
			marginLeft: 'auto'
		},
		continueButtonGridElement: {
		},
		button: {
			fontFamily: 'Open Sans, sans-serif',
			borderRadius: 5,
			fontWeight: 600,
			fontSize: 18,
			lineHeight: 1.3,
			opacity: '1 !important',
			color: '#000',
			paddingLeft: 15,
			paddingRight: 15,
			minWidth: 'auto'
		},
		buttonCancel: {
		},
		buttonContinue: {
			background: theme.palette.primary.main,
			color: 'white',
			textShadow: 'none',
			'&[class*=contained][class*=disabled]': {
				backgroundColor: '#B3B9C0'
			},
			marginLeft: 10
		},

		/* info icon */
		infoIconButton: {
			position: 'relative',
			width: 16,
			height: 16,
			margin: '-2px 0 0 5px',
			color: theme.palette.colors.white,
			backgroundColor: '#6F99BD',
			borderColor: '#6F99BD',
			padding: 0,
			'&:hover': {
				backgroundColor: `${theme.palette.colors.epsilonHover} !important`,
				borderColor: `${theme.palette.colors.epsilonHover} !important`
			}
		},
		tooltipArrow: {
			position: 'absolute',
			fontSize: 6,
			width: '3em',
			height: '1em',
			bottom: 0,
			left: '50%',
			transform: 'translateX(-50%)',
			marginBottom: '-0.95em',
			'&::before': {
				content: '""',
				margin: 'auto',
				display: 'block',
				width: 0,
				height: 0,
				borderStyle: 'solid',
				borderWidth: '1em 1em 0 1em',
				borderColor: `${theme.palette.common.black} transparent transparent transparent`,
			},
		},
		infoTooltip: {
			padding: 7,
			backgroundColor: theme.palette.common.black,
		},
		infoTooltipText: {
			color: theme.palette.common.white,
			opacity: 1
		},
		/* tooltip contnet */
		tooltipList: {
			margin: '0 5px',
		},
		tooltipListItem: {
			textAlign: 'left',
			fontSize: 12,
			lineHeight: 1.5,
			position: 'relative',
			padding: '0 0 0 10px',
			'&:before': {
				content: '""',
				display: 'inline-block',
				width: '3px',
				height: '3px',
				borderRadius: 3,
				background: '#fff',
				position: 'absolute',
				top: 7,
				left: 0
			},
		},

		/* error message */
		errorMessage:  {
			color: theme.palette.error.main,
			fontSize: 14,
			lineHeight: 1.5,
			opacity: 1,
			textAlign: 'left',
			marginTop: 0,
			marginBottom: 15,
			'& a': {
				color: theme.palette.primary.main
			}
		},

		/* loading icon */
		loadingWrapper: {
			position: 'absolute',
			top: '50%',
			left: '50%',
			transform: 'translate(-50%, -50%)'
		},
		loadingMessage: {
			fontSize: 16,
			lineHeight: 1.5,
			opacity: 1
		},
		loadingIcon: {
			display: 'block',
			height: '24px',
			width: '24px',
			margin: '0 auto 10px',
			fill: '#96DCFD',
			animation: 'spin 2s linear infinite'
		},
		'@keyframes spin': {
			'0': {
				transform: 'rotate(0deg)'
			},
			'100%': {
				transform: 'rotate(360deg)'
			}
		},

		...getTableStyleProps(USER_TABLE_REDUCE_USERS, theme),
		
		/* user table */
		tableWrapper: {
			width: 'calc(100% + 15px)',
		}
	};
};

const errors = {
	[ERRORS.API_REQUEST_LIMIT_EXCEEDED] : localize('error-cb-api-rate-limit-reached'),
	[ERRORS.OFFLINE] : localize('subscriptions-error-offline'),
};

@withStyles(styles)
class ReduceUsersModal extends Component {

	constructor(props) {
		super(props);

		this.state = {
			...this.getStateFromProps(props),
			sortKey: getSavedTableSettings(this.props.settings, USER_TABLE_REDUCE_USERS, 'sortKey'),
			sortOrder: getSavedTableSettings(this.props.settings, USER_TABLE_REDUCE_USERS, 'sortOrder'),
			userQuantity: props.quantityFromQueryParam || this.props.getQuantityInputValue(QUANTITY_TYPE.SEATS),
			apiRequestError: false,
			apiRequestSuccess: false,
			xhrInProgress: false,
			errors: {}
		};

		this.scrollbarRef = React.createRef(null);
	}

	getStateFromProps(props) {
		const { rawDataById, selectedId } = props.companies;
		const company = rawDataById[selectedId];
		const { users } = company;
		return { users };
	}

	render() {
		const { modalShown, resetModal, classes } = this.props;

		return (
			<Dialog
				open={modalShown}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
				onExited={resetModal}
				BackdropProps={{ style: { backgroundColor: 'rgba(46, 63, 79, 0.4)' } }}
				classes={{ paper: classes.dialogPaper }}
				PaperProps={{
					style: {
						border: 0,
						width: 309,
						borderRadius: 5,
						boxShadow: '0px 4px 24px rgba(0, 0, 0, 0.08)'
					}
				}}
			>
				<div className={classes.dialogWrapper}>
					<IconButton
						className={classes.closeDialog}
						component='span'
						aria-label='Close'
						onClick={() => this.closeDialog()}
					>
						<XIcon className={classes.closeDialogIcon} />
					</IconButton>
					{(() => {
						if (this.state.xhrInProgress) {
							return this.renderLoading();
						} else if (this.state.apiRequestSuccess) {
							this.props.cb();
						} else if (this.state.apiRequestError) {
							return this.renderContent();
						} else {
							return this.renderContent();
						}
					})()}
				</div>
			</Dialog>
		);
	}

	closeDialog() {
		this.props.hideModal();
	}

	renderLoading() {
		const { classes } = this.props;
		return (
			<div className={classes.loadingWrapper}>
				<SpinnerIcon className={classes.loadingIcon} />
				<Typography className={classes.loadingMessage} variant="body2">
					{localize('subscriptions-modal-updating-users')}
				</Typography>
			</div>
		);
	}	

	renderErrorMessage() {
		const errorMessage = _.get(this.state, 'errors.apiError');
		const { classes } = this.props;
		return (
			<Typography className={classes.errorMessage} variant="body2" dangerouslySetInnerHTML={{ __html: errorMessage }} />
		);		
	}

	getNumberOfRemainingUsersToReduce(nonGuestUsers, customerEnteredQuantity, freeSeatsIncluded) {
		let nrOfUsersToReduce = nonGuestUsers.length - Math.max(customerEnteredQuantity, freeSeatsIncluded);

		nonGuestUsers.forEach(nonGuestUser => {
			if (this.props.companies.pendingReduceUsers.find(reducedUser => reducedUser.email === nonGuestUser.email)) {
				nrOfUsersToReduce -= 1;
			}
		});

		return nrOfUsersToReduce > 0 ? nrOfUsersToReduce : 0;
	}

	renderContent() {
		const { classes, freeSeatsIncluded } = this.props;
		const nonGuestUsers = filterNonGuestUsers(this.props.company.users);
		const nrOfRemainingUsersToReduce =
			this.getNumberOfRemainingUsersToReduce(nonGuestUsers, this.state.userQuantity, freeSeatsIncluded);

		return (
			<Fragment>
				<DialogTitle
					variant='body1'
					color='default'
					className={classes.dialogTitle}>
					{localize('subscription-reduce-users-title')}
				</DialogTitle>
				<DialogContent>
					<Grid container direction="column">
						<Typography
							className={classNames(classes.introText, classes.description)}
							variant="body1"
							dangerouslySetInnerHTML={{ 
								__html: localize('subscription-reduce-users-description', freeSeatsIncluded)
							}} />

						<Typography
							className={classNames(classes.introText, classes.remaining)}
							variant="body1"
							dangerouslySetInnerHTML={{
								__html: localize('subscription-reduce-seats-remaining',
								nrOfRemainingUsersToReduce.toString())
							}} />
						
						{Object.keys(this.state.errors).length > 0 && this.renderErrorMessage()}

						{this.renderUserTable(USER_TABLE_REDUCE_USERS, [USER_ROLE_ADMIN, USER_ROLE_BASIC])}

						<Grid 
							item
							container
							direction="row"
							justify="flex-start"
							className={classNames(classes.buttonsContainer)}>
							<Grid item className={classes.aboutRolesGridElement}>
								<Typography 
									className={classNames(classes.aboutRoles)}>
									{localize('subscription-reduce-about-roles')}
								</Typography>
								<RolesTooltip tableId={USER_TABLE_REDUCE_USERS} />
							</Grid>							
							<Grid item className={classes.cancelButtonGridElement}>
								<Button
									variant='outlined'
									color='primary'
									data-tid="button-reduce-users-cancel"
									className={classNames(classes.button, classes.buttonCancel)}
									onClick={() => this.closeDialog()}
									disabled={false}>
									{localize('cancel')}
								</Button>
							</Grid>
							<Grid item className={classes.continueButtonGridElement}>
								<Button
									variant='contained'
									color='primary'
									data-tid="button-reduce-users-continue"
									className={classNames(classes.button, classes.buttonContinue)}
									onClick={() => this.submitForm()}
									disabled={!this.isFormValid()}>
									{localize('save-and-continue')}
								</Button>
							</Grid>
						</Grid>
					</Grid>
				</DialogContent>
			</Fragment>
		);
	}

	renderUserTable(tableId, renderRoles) {

		const { classes } = this.props;
		const { users } = this.state;

		const { sortKey, sortOrder } = this.state;
		const usersToRender = sortUsers(users.filter(user => renderRoles.includes(user.role)), sortKey, sortOrder);

		if (usersToRender.length === 0) {
			return (
				<Typography variant='body1' className={classes.noUsersFound}>
					{localize('users-table-no-guests-found')}
				</Typography>);
		} else {
			return (
				<div className={classes.tableWrapper}>
					<Table className={classes.table}>
						<TableHead>
							<TableRow className={classes.tableHeadRow}>
								<TableCell
									padding='dense'
									className={classNames(
												classes.noBorderedCell,
												classes.tableNameCellHeader,
												classes.tableCellHeader,
												classes.tableHasSortArrow
									)}>
									<IconButton
										className={classNames({
											[classes.sortArrow]: true,
											['sortArrow']: true,
											['desc']: sortKey === TABLE_COLUMNS.FULL_NAME &&
														sortOrder === SORT_ORDER.DESC,
											['active']: sortKey === TABLE_COLUMNS.FULL_NAME
										})}
										component='span'
										aria-label={localize('users-table-change-sorting-order')}
										onClick={() => this.sortTable(tableId, TABLE_COLUMNS.FULL_NAME)}
									>
										<SortArrow className={classes.sortArrowIcon} />
									</IconButton>
									{localize('users-table-header-name')}
								</TableCell>
								<TableCell
									padding='dense'
									className={classNames(
												classes.noBorderedCell,
												classes.tableEmailCellHeader,
												classes.tableCellHeader,
												classes.tableHasSortArrow)}>
									<IconButton
										className={classNames({
											[classes.sortArrow]: true,
											['sortArrow']: true,
											['desc']: sortKey === TABLE_COLUMNS.EMAIL && sortOrder === SORT_ORDER.DESC,
											['active']: sortKey === TABLE_COLUMNS.EMAIL
										})}
										component='span'
										aria-label={localize('users-table-change-sorting-order')}
										onClick={() => this.sortTable(tableId, TABLE_COLUMNS.EMAIL)}
									>
										<SortArrow className={classes.sortArrowIcon} />
									</IconButton>											
									{localize('users-table-header-email')}
								</TableCell>
								<TableCell
									padding='none'
									className={classNames(
												classes.noBorderedCell,
												classes.tableRoleCellHeader,
												classes.tableCellHeader,
												classes.tableHasSortArrow
									)}
								>
									{[USER_TABLE_REDUCE_USERS, USER_TABLE_ADMINS_AND_MEMBERS].includes(tableId) && (
										<IconButton
											className={classNames({
												[classes.sortArrow]: true,
												['sortArrow']: true,
												['desc']: sortKey === TABLE_COLUMNS.ROLE && sortOrder === SORT_ORDER.DESC,
												['active']: sortKey === TABLE_COLUMNS.ROLE
											})}
											component='span'
											aria-label={localize('users-table-change-sorting-order')}
											onClick={() => this.sortTable(tableId, TABLE_COLUMNS.ROLE)}
										>
											<SortArrow className={classes.sortArrowIcon} />
										</IconButton>											
									)}
									{localize('users-table-header-user-role')}
								</TableCell>
								<TableCell
									padding='dense'
									className={classNames(
									classes.noBorderedCell,
									classes.tableSelectActionCellHeader,
									classes.tableCellHeader,
									classes.tableHasSortArrow
									)}
								>
									{localize('users-table-header-select-action')}
									<Tooltip
										placement="top"
										title={
											<React.Fragment>
												<List className={classes.tooltipList}>
													<ListItem className={classes.tooltipListItem}>
														{localize('subscription-reduce-reduce-users-action-info-keep-role')}
													</ListItem>
													<ListItem className={classes.tooltipListItem}>
														{localize('subscription-reduce-reduce-users-action-info-change-to-guest')}
													</ListItem>
													<ListItem className={classes.tooltipListItem}>
														{localize('subscription-reduce-reduce-users-action-info-remove')}
													</ListItem>
												</List>
												<span className={classes.tooltipArrow} />
											</React.Fragment>
										}
										classes={{
											tooltip: classes.infoTooltip
										}}
									>
										<IconButton
											className={classes.infoIconButton}
											color='primary'
											component='span'
											disableRipple
										>
											<Info />
										</IconButton>
									</Tooltip>
															
								</TableCell>
							</TableRow>
						</TableHead>
					</Table>						
							
					<Scrollbars
						ref={this.scrollbarRef}
						style={{ height: 240 }}
						autoHide={false}
						
						renderThumbVertical={({ style, ...props }) =>
							(<div
								{...props}
								style={{
									...style,
									width: 8,
									backgroundColor: '#6F99BD',
									opacity: 0.5,
									borderRadius: 4
								}}/>)
						}
					>
						<Table className={classes.table}>
							<TableBody>
								{this.renderUserRows(usersToRender)}
							</TableBody>
						</Table>					
					</Scrollbars>						
				</div>						
			);
		}
	}	

	renderUserRows(usersToRender) {
		const { classes } = this.props;
		const { currentUserEmail } = this.props;

		return usersToRender.map((user, index) => {
			const { name, email, role, userId, externalIds } = encodeUser(user);
			const key = `user-row-${index}`;

			let selectedValue;

			// State is stored to redux state in case user reopens this popup
			// Note that redux.companies.pendingReduceUsers will be cleared if users closes this popup,
			// makes changes on Users page, and then opens this popup again
			const pendingReduceUserEntry = this.props.companies.pendingReduceUsers.find(user => user.email === email);
			if (pendingReduceUserEntry) {
				selectedValue = pendingReduceUserEntry.action;
			} else {
				selectedValue = REDUCE_ACTION.KEEP_ROLE;
			}

			return (
				<TableRow 
					key={key}
					hover
					className={classNames({
						[classes.tableBodyRow]: true,
					})}
				>
					<TableCell padding='dense' className={classNames(classes.tableCellBody, classes.tableNameCellBody)}>
						{(currentUserEmail === email) ? localize('users-table-name-you', name) : name}
					</TableCell>
					<TableCell padding='dense' className={classNames(classes.tableCellBody, classes.tableEmailCellBody)}>
						{email}
					</TableCell>
					<TableCell padding='dense' className={classNames(classes.tableCellBody, classes.tableRoleCellBody)}>
						{role}
					</TableCell>
					<TableCell
						padding='none'
						className={
							classNames(classes.tableCellBody, classes.tableCellReduceAction, classes.tableSelectActionCellBody)
						}>
						<Select
							id={`select-reduce-action-role-${index}`}
							data-tid={`select-reduce-action-role-${index}`}
							name={`editUser-${email}`}
							onChange={(event) => this.handleAction(email, userId, externalIds, event.target.value)}
							className={classes.roleSelect}
							disableUnderline
							fullWidth
							IconComponent={SelectArrow}
							MenuProps={{ classes: { paper: classes.roleSelectItems } }}
							value={selectedValue}
							disabled={currentUserEmail === email}
						>
							{REDUCE_ACTIONS.map(option => (
								<MenuItem key={option.key} value={option.key}>
									{option.value}
								</MenuItem>
							))}
						</Select>
					</TableCell>
				</TableRow>
			);
		}, this);
	}

	sortTable(tableId, newSortColumnKey) {
		const { sortKey: currentSortKey, sortOrder: currentSortOrder } = this.state;
		const newState = {};

		if (!currentSortKey) {
			newState.sortKey = newSortColumnKey;
			newState.sortOrder = SORT_ORDER.DESC;
		} else if (currentSortKey === newSortColumnKey) {
			newState.sortOrder = currentSortOrder === SORT_ORDER.ASC ? SORT_ORDER.DESC : SORT_ORDER.ASC;
			newState.sortKey = currentSortKey;
		} else if (currentSortKey !== newSortColumnKey) {
			newState.sortKey = newSortColumnKey;
			newState.sortOrder = SORT_ORDER.ASC;

		}
		this.setState(newState);

		// use same settings in all companies
		const userPageSettings = _.get(this.props.settings,
			`${CAP_KEY}.${USER_PAGE_SETTINGS_KEY}`, {});

		userPageSettings[tableId] || (userPageSettings[tableId] = {});
		userPageSettings[tableId].sortKey = newState.sortKey;
		userPageSettings[tableId].sortOrder = newState.sortOrder;

		this.props.writeUserSettings({
			[USER_PAGE_SETTINGS_KEY]: userPageSettings
		});			
	}

	handleAction(email, userId, externalIds, action) {
		this.props.updatePendingReduceUser(email, userId, externalIds, action);
	}

	componentWillReceiveProps(nextProps) {
		this.setState({
			...this.getStateFromProps(nextProps),
		});

		if (this.props.companies.batchReduceUsersErrorId !== nextProps.companies.batchReduceUsersErrorId &&
			nextProps.companies.batchReduceUsersErrorId !== null) {
			this.handleApiErrors(nextProps);
		}

		if (this.props.companies.batchReduceUsersSuccess !== nextProps.companies.batchReduceUsersSuccess &&
			nextProps.companies.batchReduceUsersSuccess === true) {
			this.setState({
				xhrInProgress: false,
				apiRequestError: false,
				apiRequestSuccess: true,
				errors: { apiError: null }
			});
		}
	}

	handleApiErrors(nextProps) {
		if (nextProps.companies.batchReduceUsersErrorId) {
			const errorMessage = nextProps.companies.batchReduceUsersErrorId &&
				errors[nextProps.companies.batchReduceUsersErrorId] ||
				localize('subscriptions-error-unknown');
			this.setState({
				xhrInProgress: false,
				apiRequestError: true,
				apiRequestSuccess: false,
				errors: { apiError: errorMessage }
			});
		}
	}

	isFormValid() {
		const nonGuestUsers = filterNonGuestUsers(this.props.company.users);
		return this.getNumberOfRemainingUsersToReduce(nonGuestUsers, this.state.userQuantity, this.props.freeSeatsIncluded) === 0;
	}

	componentDidMount() {
		trackReduceUsersModal(getTrackingOptions(this.props.company));
	}

	submitForm() {
		const nonGuestUsers = filterNonGuestUsers(this.props.company.users);
		let nrOfUsersToTurnToGuest = 0;
		let nrOfUsersToDelete = 0;

		// This is data for all users, it contains all users in updated state
		const usersData = nonGuestUsers.map(originalUser => {
			const userPendingUpdate = this.props.companies.pendingReduceUsers
				.find(reducedUser => originalUser.email === reducedUser.email);

			if (userPendingUpdate) {
				if (userPendingUpdate.action === REDUCE_ACTION.CHANGE_TO_GUEST) {
					const updatedUser = _.clone(userPendingUpdate);
					updatedUser.role = USER_ROLE_GUEST;
					nrOfUsersToTurnToGuest++;
					return updatedUser;
				} else if (userPendingUpdate.action === REDUCE_ACTION.REMOVE) {
					const updatedUser = _.clone(userPendingUpdate);
					nrOfUsersToDelete++;
					return updatedUser;
				}
			}
		}).filter(item => !!item);

		trackReducedUsers(nrOfUsersToTurnToGuest, nrOfUsersToDelete, getTrackingOptions(this.props.company));

		this.setState({
			xhrInProgress: true,
			apiRequestError: false,
			apiRequestSuccess: false,
			errors: { apiError: null }
		});

		this.props.batchReduceUsers(usersData);
	}
}

ReduceUsersModal.propTypes = {
	modalShown: PropTypes.bool,
	hideModal: PropTypes.func,
	resetModal: PropTypes.func,
	classes: PropTypes.object,
	company: PropTypes.object,
	companies: PropTypes.object,
	cb: PropTypes.func,
	currentUserEmail: PropTypes.string,
	getQuantityInputValue: PropTypes.func,
	settings: PropTypes.object,
	writeUserSettings: PropTypes.func.isRequired,
	updatePendingReduceUser: PropTypes.func.isRequired,
	batchReduceUsers: PropTypes.func.isRequired,
	freeSeatsIncluded: PropTypes.number.isRequired,
	discount: PropTypes.object.isRequired,
	quantityFromQueryParam: PropTypes.number
};

const mapStateToProps = state => ({
	company: state.companies.rawDataById[state.companies.selectedId],
	modalShown: state.modal.modalShown,
	companies: state.companies,
	app: state.app,
	currentUserEmail: state.session.user.mainEmail,
	discount: state.discount,
	settings: state.session.user.settings
});

const mapDispatchToProps = dispatch => bindActionCreators({
	hideModal,
	resetModal,
	writeUserSettings,
	updatePendingReduceUser,
	batchReduceUsers
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ReduceUsersModal);


// WEBPACK FOOTER //
// ./src/components/Modal/ReduceUsersModal.js